import { Paper } from "@mui/material";

import { useListTechCommunitiesQuery } from "api/public/techCommunities/techCommunities.api";
import DefaultDataGrid from "components/MUI/DataGrid/DefaultDataGrid";

import {
  internationalCommunitiesColumns,
  usCommunitiesColumns,
} from "./TechCommunities.columns";

interface TechCommunitiesTableProps {
  isInternational?: boolean;
}

const TechCommunitiesTable = ({
  isInternational = false,
}: TechCommunitiesTableProps) => {
  const { data: communities = [], isLoading } = useListTechCommunitiesQuery({
    isInternational,
  });

  const columns = isInternational
    ? internationalCommunitiesColumns
    : usCommunitiesColumns;

  const title = isInternational ? "International Communities" : "Communities";

  return (
    <Paper
      elevation={1}
      sx={{
        overflowX: "auto",
        margin: 0,
        padding: 0,
      }}
    >
      <DefaultDataGrid
        title={title}
        columns={columns}
        rows={communities}
        getRowId={(row) => row.community_id}
        loading={isLoading}
        localeText={{
          noRowsLabel: `No ${title} Found`,
        }}
        initialState={{
          pagination: {
            paginationModel: { pageSize: 20 },
          },
        }}
        pageSizeOptions={[10, 20, 50]}
      />
    </Paper>
  );
};

export default TechCommunitiesTable;
